export const marketplace = 'AdicionarIntegracao';
export const editarIntegracao = 'EditarIntegracao';
export const removerIntegracao = 'RemoverIntegracao';
export const listarIntegracoes = 'ListarIntegracoes';
export const consultas = 'ChamarServico';
export const integracoes = {
  marketplace: [marketplace],
  configuradas: [removerIntegracao, editarIntegracao, listarIntegracoes],
  consultas: [consultas]
};
